var render = function render(){var _vm=this,_c=_vm._self._c;return _c('display',{attrs:{"models":_vm.recurrentes,"mostrar_models_que_vinienen_por_prop_siempre":"","model_name":_vm.model_name,"loading":_vm.loading,"properties":_vm.modelPropertiesFromName(_vm.model_name)}})
}
var staticRenderFns = []

export { render, staticRenderFns }